export const STUDENT_FIELDS = [
  ["no", "No"], ["kode_unik", "Kode Unik"],
  ["nama_perguruan_tinggi", "Nama Perguruan Tinggi"], ["kode_pt", "Kode PT"],
  ["pin", "PIN"], ["nim", "NIM"], ["nama_mahasiswa", "Nama Mahasiswa"],
  ["nik", "NIK"], ["tanggal_lahir", "Tanggal Lahir"], ["nama_ibu", "Nama Ibu"],
  ["semester", "Semester"], ["status_mahasiswa", "Status Mahasiswa"],
  ["angkatan", "Angkatan"], ["tahun_penetapan", "Tahun Penetapan"], ["kode_prodi", "Kode Prodi"],
  ["nama_prodi", "Nama Prodi"], ["akreditasi_prodi", "Akreditasi Prodi"],
  ["bidang_prodi", "Bidang Prodi"], ["no_kipk", "No KIPK"],
  ["no_rekening", "No Rekening"], ["nama_di_rekening", "Nama di Rekening"],
  ["bank", "Bank"], ["status_rekening", "Status Rekening"],
  ["status_penyerahan_buku_tabungan", "Status Penyerahan Buku Tabungan"],
  ["lokasi_penyerahan", "Lokasi Penyerahan"], ["tanggal_penyerahan", "Tanggal Penyerahan"],
  ["jam_penyerahan", "Jam Penyerahan"], ["kota_perguruan_tinggi", "Kota Perguruan Tinggi"],
  ["alamat", "Alamat"], ["no_hp", "No HP"],
  ["skema_bantuan", "Skema Bantuan"], ["biaya_hidup", "Biaya Hidup"],
  ["ukt_spp", "UKT SPP"], ["kategori_beasiswa", "Kategori Beasiswa"],
  ["jenis_prodi", "Jenis Prodi"], ["periode", "periode"],
];

export const calculateCurrentSemester = (angkatan, currentDate = new Date()) => {
  const match = String(angkatan || "").match(/(?:19|20)\d{2}/);
  if (!match) return "";
  const cohortYear = Number(match[0]);
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Jakarta", year: "numeric", month: "2-digit",
  }).formatToParts(currentDate);
  const values = Object.fromEntries(parts.map((part) => [part.type, part.value]));
  const currentYear = Number(values.year);
  const currentMonth = Number(values.month);
  const yearDelta = currentYear - cohortYear;
  if (yearDelta <= 0) return "1";
  if (currentMonth >= 8) return String((2 * yearDelta) + 1);
  if (currentMonth >= 2) return String(2 * yearDelta);
  return String(Math.max(1, (2 * yearDelta) - 1));
};

export const emptyStudentData = () => ({
  ...Object.fromEntries(STUDENT_FIELDS.map(([key]) => [key, ""])),
  status_mahasiswa: "Aktif",
});